import { ComponentProps, memo } from 'react'
import { useFragment } from 'react-relay/hooks'
import { graphql } from 'relay-runtime'
import PersonAvatar from 'components/PersonAvatar'
import UserAvatar from 'components/UserAvatar'
import { RecipientAvatar_Recipient$key } from '__generated__/RecipientAvatar_Recipient.graphql'
import { Avatar } from '@mui/material'
import { SmartToy } from '@mui/icons-material'

interface IRecipientAvatarProps extends ComponentProps<typeof PersonAvatar> {
  recipientFragmentRef: RecipientAvatar_Recipient$key | null | undefined
}

function RecipientAvatar({ recipientFragmentRef, ...restProps }: IRecipientAvatarProps) {
  const recipient = useFragment(graphql`
    fragment RecipientAvatar_Recipient on Recipient {
      __typename
      
      ... on User {
        ...UserAvatarContainer_User
      }
      
      ... on ChatBot {
        name
        avatarUrl
      }
    }
  `, recipientFragmentRef)

  if (recipient?.__typename === 'User') return <UserAvatar userFragmentRef={recipient} {...restProps} />

  if (recipient?.__typename === 'ChatBot') {
    return (
      <Avatar
        alt={recipient?.name || undefined}
        {...restProps}
      >
        <SmartToy />
      </Avatar>
    )
  }

  return <PersonAvatar {...restProps} />
}

export default memo(RecipientAvatar)
